// (function () {
//   'use strict';
//   var reduced = function () {
//     try {
//       return matchMedia('(prefers-reduced-motion: reduce)').matches;
//     } catch (e) {
//       return false;
//     }
//   };
//   var cartImg = function (o) {
//     if (!o || typeof o !== 'object') return '';
//     var t = function (s) {
//       return typeof s === 'string' && s.trim();
//     };
//     if (t(o.image)) return o.image;
//     var fi = o.featured_image;
//     if (t(fi)) return fi;
//     if (fi && t(fi.url)) return fi.url;
//     var items = o.items;
//     if (!items || !items.length) return '';
//     var last = items[items.length - 1];
//     if (t(last.image)) return last.image;
//     return last.featured_image && t(last.featured_image.url) ? last.featured_image.url : '';
//   };
//   var goodRect = function (el) {
//     if (!el || !el.getBoundingClientRect) return null;
//     var r = el.getBoundingClientRect();
//     return r.width > 8 && r.height > 8 ? r : null;
//   };
//   var sourceRect = function (form, opener) {
//     var r;
//     var addBtn =
//       form &&
//       (form.querySelector('button[name="add"][type="submit"]') ||
//         form.querySelector('button.add-to-cart__submit[type="submit"]') ||
//         form.querySelector('button.cartb[type="submit"]') ||
//         form.querySelector('button.product-form__submit[type="submit"]') ||
//         form.querySelector('button.cartb') ||
//         form.querySelector('[type="submit"]'));
//     r = goodRect(addBtn);
//     if (r) return r;
//     var btnRow = form && form.querySelector('.product-form__buttons');
//     r = goodRect(btnRow);
//     if (r) return r;
//     r = goodRect(opener);
//     if (r) return r;
//     r = goodRect(form);
//     if (r) return r;
//     var z = 36,
//       w = innerWidth,
//       h = innerHeight;
//     return { left: w / 2 - z, top: h / 2 - z, width: 2 * z, height: 2 * z };
//   };
//   var stylesOnce = function () {
//     var id = 'cart-fly-to-cart-s';
//     var css =
//       '.cart-fly-to-cart{position:fixed;z-index:2147483646;width:40px;height:40px;pointer-events:none;border-radius:50%;overflow:hidden;box-shadow:0 2px 12px rgba(0,0,0,.16);will-change:transform}' +
//       '.cart-fly-to-cart img{display:block;width:40px;height:40px;border-radius:50%;object-fit:cover}';
//     var el = document.getElementById(id);
//     if (el) {
//       el.textContent = css;
//       return;
//     }
//     el = document.createElement('style');
//     el.id = id;
//     el.textContent = css;
//     document.head.appendChild(el);
//   };
//   var fly = function (from, url, icon, done) {
//     var target = (icon && document.body.contains(icon) && icon) || document.querySelector('#cart-icon-bubble');
//     if (!target || !url) {
//       done();
//       return;
//     }
//     var to = target.getBoundingClientRect();
//     if (to.width < 1 && to.height < 1) {
//       done();
//       return;
//     }
//     stylesOnce();
//     var box = document.createElement('div');
//     box.className = 'cart-fly-to-cart';
//     box.setAttribute('aria-hidden', 'true');
//     var img = document.createElement('img');
//     img.alt = '';
//     img.src = url;
//     var flySize = 40;
//     box.appendChild(img);
//     var sx = from.left + from.width / 2 - flySize / 2,
//       sy = from.top + from.height / 2 - flySize / 2;
//     box.style.cssText = 'left:' + sx + 'px;top:' + sy + 'px;width:' + flySize + 'px;height:' + flySize + 'px';
//     var end = function () {
//       box.remove();
//       done();
//     };
//     var run = function () {
//       document.body.appendChild(box);
//       to = target.getBoundingClientRect();
//       var tcx = to.left + to.width / 2,
//         tcy = to.top + to.height / 2,
//         fcx = sx + flySize / 2,
//         dx = tcx - fcx,
//         dy = tcy - (sy + flySize / 2),
//         dist = Math.sqrt(dx * dx + dy * dy) || 1,
//         bulge = Math.min(72, Math.max(20, dist * 0.2)),
//         nx = -dy / dist,
//         ny = dx / dist,
//         p1x = Math.min(-16, dx * 0.02 - 26),
//         p1y = Math.min(-3, dy * 0.04 - 5),
//         p2x = dx * 0.74 + nx * bulge,
//         p2y = dy * 0.74 + ny * bulge,
//         dur = 920,
//         ease = 'cubic-bezier(0.33, 0.72, 0.28, 1)',
//         kf = [],
//         n = 14,
//         i,
//         t,
//         u,
//         uu,
//         tt,
//         x,
//         y;
//       if (box.animate) {
//         for (i = 0; i <= n; i++) {
//           t = i / n;
//           u = 1 - t;
//           uu = u * u;
//           tt = t * t;
//           x = uu * u * 0 + 3 * uu * t * p1x + 3 * u * tt * p2x + tt * t * dx;
//           y = uu * u * 0 + 3 * uu * t * p1y + 3 * u * tt * p2y + tt * t * dy;
//           kf.push({
//             transform: 'translate3d(' + x.toFixed(2) + 'px,' + y.toFixed(2) + 'px,0)',
//             offset: i === n ? 1 : t,
//           });
//         }
//         var a = box.animate(kf, { duration: dur, easing: ease, fill: 'forwards' });
//         a.onfinish = end;
//         a.oncancel = end;
//       } else {
//         setTimeout(end, dur);
//       }
//     };
//     if (img.complete && img.naturalWidth > 0) {
//       run();
//     } else if (typeof img.decode === 'function') {
//       img.decode().then(run).catch(run);
//     } else {
//       requestAnimationFrame(run);
//     }
//   };
//   function play(o) {
//     var d = o.cartDrawer,
//       st = o.parsedState,
//       form = o.productForm,
//       opener = o.quickAddOpener,
//       cb = o.onFlyComplete;
//     if (!d || typeof d.renderContents !== 'function') {
//       cb && cb();
//       return;
//     }
//     var finish = function () {
//       try {
//         cb && cb();
//       } catch (e) {
//         console.error(e);
//       }
//     };
//     var startRect = sourceRect(form, opener);
//     var url = cartImg(st);
//     if (reduced()) {
//       d.renderContents(st, { openDrawer: false });
//       queueMicrotask(finish);
//       return;
//     }
//     if (!url || !startRect || startRect.width < 1 || startRect.height < 1) {
//       d.renderContents(st, { openDrawer: false });
//       queueMicrotask(finish);
//       return;
//     }
//     d.renderContents(st, { openDrawer: false });
//     queueMicrotask(function () {
//       fly(startRect, url, document.querySelector('#cart-icon-bubble'), finish);
//     });
//   }
//   window.ThemeCartFlyToCart = { play: play };
// })();



// (function () {
//   'use strict';
//   var S = 40,
//     D = 760;
//   function reduced() {
//     try {
//       return matchMedia('(prefers-reduced-motion: reduce)').matches;
//     } catch (e) {
//       return false;
//     }
//   }
//   function cartImg(o) {
//     if (!o) return '';
//     if (o.image) return o.image;
//     var it = o.items;
//     return it && it.length ? it[it.length - 1].image || '' : '';
//   }
//   function preview(pf) {
//     var root =
//       pf &&
//       (pf.closest('.wbproduct-container,.card-wrapper,.product-card-wrapper,.product') || pf);
//     var img = root && root.querySelector('.product__media-item img,.wbimgblock img,img[src]');
//     return img ? img.currentSrc || img.src || '' : '';
//   }
//   function rect(form, opener) {
//     var btn =
//       form &&
//       (form.querySelector('button[name="add"][type="submit"]') ||
//         form.querySelector('button.product-form__submit[type="submit"]') ||
//         form.querySelector('[type="submit"]'));
//     var el = btn || (form && form.querySelector('.product-form__buttons')) || opener || form;
//     if (!el || !el.getBoundingClientRect) return null;
//     var r = el.getBoundingClientRect();
//     if (r.width < 8 || r.height < 8) return null;
//     return { left: r.left, top: r.top, width: r.width, height: r.height };
//   }
//   function patchIcon(st) {
//     var html = st.sections && st.sections['cart-icon-bubble'];
//     if (!html) return;
//     var el = document.getElementById('cart-icon-bubble');
//     if (!el) return;
//     var inner = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
//     if (inner) el.innerHTML = inner.innerHTML;
//   }
//   function css() {
//     var id = 'cart-fly-to-cart-s',
//       t =
//         '.cart-fly-to-cart{position:fixed;z-index:2147483646;width:40px;height:40px;pointer-events:none;border-radius:50%;overflow:hidden;box-shadow:0 2px 12px rgba(0,0,0,.16);will-change:transform}.cart-fly-to-cart img{width:40px;height:40px;border-radius:50%;object-fit:cover}',
//       e = document.getElementById(id);
//     if (e) e.textContent = t;
//     else {
//       e = document.createElement('style');
//       e.id = id;
//       e.textContent = t;
//       document.head.appendChild(e);
//     }
//   }
//   function fly(from, url, done) {
//     var target = document.querySelector('#cart-icon-bubble');
//     if (!target || !url) return done();
//     css();
//     var box = document.createElement('div');
//     box.className = 'cart-fly-to-cart';
//     box.setAttribute('aria-hidden', 'true');
//     var im = document.createElement('img');
//     im.alt = '';
//     im.src = url;
//     box.appendChild(im);
//     var sx = from.left + from.width / 2 - S / 2,
//       sy = from.top + from.height / 2 - S / 2;
//     box.style.cssText = 'left:' + sx + 'px;top:' + sy + 'px';
//     document.body.appendChild(box);
//     var tr = target.getBoundingClientRect(),
//       dx = tr.left + tr.width / 2 - (sx + S / 2),
//       dy = tr.top + tr.height / 2 - (sy + S / 2),
//       dist = Math.hypot(dx, dy) || 1,
//       bulge = Math.min(72, Math.max(20, dist * 0.2)),
//       nx = -dy / dist,
//       ny = dx / dist,
//       p1x = Math.min(-16, dx * 0.02 - 26),
//       p1y = Math.min(-3, dy * 0.04 - 5),
//       p2x = dx * 0.74 + nx * bulge,
//       p2y = dy * 0.74 + ny * bulge,
//       end = function () {
//         box.remove();
//         done();
//       },
//       kf = [],
//       i,
//       u,
//       tt,
//       x,
//       y;
//     if (!box.animate) return setTimeout(end, D);
//     for (i = 0; i <= 10; i++) {
//       u = 1 - (tt = i / 10);
//       x = u * u * u * 0 + 3 * u * u * tt * p1x + 3 * u * tt * tt * p2x + tt * tt * tt * dx;
//       y = u * u * u * 0 + 3 * u * u * tt * p1y + 3 * u * tt * tt * p2y + tt * tt * tt * dy;
//       kf.push({ transform: 'translate3d(' + x + 'px,' + y + 'px,0)', offset: i === 10 ? 1 : tt });
//     }
//     var a = box.animate(kf, { duration: D, easing: 'cubic-bezier(0.33,0.72,0.28,1)', fill: 'forwards' });
//     a.onfinish = a.oncancel = end;
//   }
//   function play(o) {
//     var d = o.cartDrawer,
//       st = o.parsedState,
//       pf = o.productForm,
//       done = function () {
//         try {
//           o.onFlyComplete && o.onFlyComplete();
//         } catch (e) {
//           console.error(e);
//         }
//       };
//     if (!d || !d.renderContents) return done();
//     var from = rect(pf, o.quickAddOpener),
//       url = preview(pf) || cartImg(st);
//     patchIcon(st);
//     if (reduced() || !url || !from) {
//       d.renderContents(st, { openDrawer: false });
//       return queueMicrotask(done);
//     }
//     d.renderContents(st, { openDrawer: false });
//     fly(from, url, done);
//   }
//   window.ThemeCartFlyToCart = { play: play };
// })();








//perfect but direct way to cart

// (function () {
//   'use strict';
//   var S = 40,
//     D = 760;
//   function reduced() {
//     try {
//       return matchMedia('(prefers-reduced-motion: reduce)').matches;
//     } catch (e) {
//       return false;
//     }
//   }
//   function cartImg(o) {
//     if (!o) return '';
//     if (o.image) return o.image;
//     var it = o.items;
//     return it && it.length ? it[it.length - 1].image || '' : '';
//   }
//   function preview(pf) {
//     var root =
//       pf &&
//       (pf.closest('.wbproduct-container,.card-wrapper,.product-card-wrapper,.product') || pf);
//     var img = root && root.querySelector('.product__media-item img,.wbimgblock img,img[src]');
//     return img ? img.currentSrc || img.src || '' : '';
//   }
//   function rect(form, opener) {
//     var btn =
//       form &&
//       (form.querySelector('button[name="add"][type="submit"]') ||
//         form.querySelector('button.product-form__submit[type="submit"]') ||
//         form.querySelector('[type="submit"]'));
//     var el = btn || (form && form.querySelector('.product-form__buttons')) || opener || form;
//     if (!el || !el.getBoundingClientRect) return null;
//     var r = el.getBoundingClientRect();
//     if (r.width < 8 || r.height < 8) return null;
//     return { left: r.left, top: r.top, width: r.width, height: r.height };
//   }
//   function patchIcon(st) {
//     var html = st.sections && st.sections['cart-icon-bubble'];
//     if (!html) return;
//     var el = document.getElementById('cart-icon-bubble');
//     if (!el) return;
//     var inner = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
//     if (inner) el.innerHTML = inner.innerHTML;
//   }
//   function css() {
//     var id = 'cart-fly-to-cart-s',
//       t =
//         '.cart-fly-to-cart{position:fixed;z-index:2147483646;width:40px;height:40px;pointer-events:none;border-radius:50%;overflow:hidden;box-shadow:0 2px 12px rgba(0,0,0,.16);will-change:transform}.cart-fly-to-cart img{width:40px;height:40px;border-radius:50%;object-fit:cover}',
//       e = document.getElementById(id);
//     if (e) e.textContent = t;
//     else {
//       e = document.createElement('style');
//       e.id = id;
//       e.textContent = t;
//       document.head.appendChild(e);
//     }
//   }
//   function cartIconRect() {
//     var target = document.querySelector('#cart-icon-bubble');
//     if (!target) return null;
//     var r = target.getBoundingClientRect();
//     return r.width > 0 && r.height > 0 && r.bottom > 0 ? r : null;
//   }
//   function syncHeaderHeight() {
//     var sticky = document.querySelector('sticky-header');
//     if (sticky && typeof sticky.syncHeaderHeightForCartFly === 'function') {
//       sticky.syncHeaderHeightForCartFly();
//     }
//   }
//   function fly(from, url, done) {
//     if (!url) return done();
//     css();
//     var box = document.createElement('div');
//     box.className = 'cart-fly-to-cart';
//     box.setAttribute('aria-hidden', 'true');
//     var im = document.createElement('img');
//     im.alt = '';
//     im.src = url;
//     box.appendChild(im);
//     var sx = from.left + from.width / 2 - S / 2,
//       sy = from.top + from.height / 2 - S / 2;
//     box.style.cssText = 'left:' + sx + 'px;top:' + sy + 'px';
//     document.body.appendChild(box);
//     var run = function () {
//       var tr = cartIconRect();
//       if (!tr) {
//         box.remove();
//         return done();
//       }
//       var dx = tr.left + tr.width / 2 - (sx + S / 2),
//         dy = tr.top + tr.height / 2 - (sy + S / 2),
//         dist = Math.hypot(dx, dy) || 1,
//         bulge = Math.min(72, Math.max(20, dist * 0.2)),
//         nx = -dy / dist,
//         ny = dx / dist,
//         p1x = Math.min(-16, dx * 0.02 - 26),
//         p1y = Math.min(-3, dy * 0.04 - 5),
//         p2x = dx * 0.74 + nx * bulge,
//         p2y = dy * 0.74 + ny * bulge,
//         end = function () {
//           box.remove();
//           done();
//         },
//         kf = [],
//         i,
//         u,
//         tt,
//         x,
//         y;
//       if (!box.animate) return setTimeout(end, D);
//       for (i = 0; i <= 10; i++) {
//         u = 1 - (tt = i / 10);
//         x = u * u * u * 0 + 3 * u * u * tt * p1x + 3 * u * tt * tt * p2x + tt * tt * tt * dx;
//         y = u * u * u * 0 + 3 * u * u * tt * p1y + 3 * u * tt * tt * p2y + tt * tt * tt * dy;
//         kf.push({ transform: 'translate3d(' + x + 'px,' + y + 'px,0)', offset: i === 10 ? 1 : tt });
//       }
//       var a = box.animate(kf, { duration: D, easing: 'cubic-bezier(0.33,0.72,0.28,1)', fill: 'forwards' });
//       a.onfinish = a.oncancel = end;
//     };
//     requestAnimationFrame(function () {
//       requestAnimationFrame(run);
//     });
//   }
//   function play(o) {
//     var d = o.cartDrawer,
//       st = o.parsedState,
//       pf = o.productForm,
//       done = function () {
//         try {
//           o.onFlyComplete && o.onFlyComplete();
//         } catch (e) {
//           console.error(e);
//         }
//       };
//     if (!d || !d.renderContents) return done();
//     if (typeof d.setHeaderStickyForDrawer === 'function') d.setHeaderStickyForDrawer(true);
//     var from = rect(pf, o.quickAddOpener),
//       url = preview(pf) || cartImg(st);
//     patchIcon(st);
//     syncHeaderHeight();
//     if (reduced() || !url || !from) {
//       d.renderContents(st, { openDrawer: false });
//       return queueMicrotask(done);
//     }
//     d.renderContents(st, { openDrawer: false });
//     syncHeaderHeight();
//     fly(from, url, done);
//   }
//   window.ThemeCartFlyToCart = { play: play };
// })();



//extra curv

// (function () {
//   'use strict';
//   var S = 44;
//   function reduced() {
//     try {
//       return matchMedia('(prefers-reduced-motion: reduce)').matches;
//     } catch (e) {
//       return false;
//     }
//   }
//   function cartImg(o) {
//     if (!o) return '';
//     if (o.image) return o.image;
//     var it = o.items;
//     return it && it.length ? it[it.length - 1].image || '' : '';
//   }
//   function preview(pf) {
//     var root =
//       pf &&
//       (pf.closest('.wbproduct-container,.card-wrapper,.product-card-wrapper,.product') || pf);
//     var img = root && root.querySelector('.product__media-item img,.wbimgblock img,img[src]');
//     return img ? img.currentSrc || img.src || '' : '';
//   }
//   function rect(form, opener) {
//     var btn =
//       form &&
//       (form.querySelector('button[name="add"][type="submit"]') ||
//         form.querySelector('button.product-form__submit[type="submit"]') ||
//         form.querySelector('[type="submit"]'));
//     var el = btn || (form && form.querySelector('.product-form__buttons')) || opener || form;
//     if (!el || !el.getBoundingClientRect) return null;
//     var r = el.getBoundingClientRect();
//     if (r.width < 8 || r.height < 8) return null;
//     return { left: r.left, top: r.top, width: r.width, height: r.height };
//   }
//   function patchIcon(st) {
//     var html = st.sections && st.sections['cart-icon-bubble'];
//     if (!html) return;
//     var el = document.getElementById('cart-icon-bubble');
//     if (!el) return;
//     var inner = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
//     if (inner) el.innerHTML = inner.innerHTML;
//   }
//   function css() {
//     var id = 'cart-fly-to-cart-s',
//       t =
//         '.cart-fly-to-cart{--offset-y:10px;position:fixed;left:0;top:0;width:var(--fly-w,44px);height:var(--fly-h,44px);z-index:2147483646;pointer-events:none;border-radius:50%;overflow:hidden;box-shadow:0 4px 18px rgba(0,0,0,.14);opacity:1;translate:var(--start-x,0) var(--start-y,0);transform:translate(-50%,-50%);will-change:translate,transform;animation-name:cart-fly-x,cart-fly-y,cart-fly-scale;animation-timing-function:var(--x-timing),var(--y-timing),var(--scale-timing);animation-duration:var(--fly-duration,.75s);animation-composition:accumulate;animation-fill-mode:both}.cart-fly-to-cart--main{--x-timing:cubic-bezier(.7,-5,.98,.5);--y-timing:cubic-bezier(.15,.57,.9,1.05);--scale-timing:cubic-bezier(.85,.05,.96,1);--fly-duration:.75s}.cart-fly-to-cart--sticky{--x-timing:cubic-bezier(.98,-.8,.92,.5);--y-timing:cubic-bezier(.14,.56,.92,1.04);--scale-timing:cubic-bezier(.86,.08,.98,.98);--fly-duration:.9s}@keyframes cart-fly-x{to{translate:var(--travel-x,0) 0}}@keyframes cart-fly-y{to{translate:0 var(--travel-y,0)}}@keyframes cart-fly-scale{0%{opacity:1}5%{opacity:1}100%{opacity:1;transform:translate(-50%,calc(-50% + var(--offset-y))) scale(.22)}}.cart-fly-to-cart img{width:100%;height:100%;object-fit:cover;border-radius:50%}',
//       e = document.getElementById(id);
//     if (e) e.textContent = t;
//     else {
//       e = document.createElement('style');
//       e.id = id;
//       e.textContent = t;
//       document.head.appendChild(e);
//     }
//   }
//   function flyDurationMs(box) {
//     return box.classList.contains('cart-fly-to-cart--sticky') ? 900 : 750;
//   }
//   function isStickyHeader() {
//     var h = document.querySelector('.section-header');
//     return !!(h && (h.classList.contains('shopify-section-header-sticky') || h.classList.contains('cart-drawer-pinned')));
//   }
//   function cartIconRect() {
//     var target = document.querySelector('#cart-icon-bubble');
//     if (!target) return null;
//     var r = target.getBoundingClientRect();
//     return r.width > 0 && r.height > 0 && r.bottom > 0 ? r : null;
//   }
//   function syncHeaderHeight() {
//     var sticky = document.querySelector('sticky-header');
//     if (sticky && typeof sticky.syncHeaderHeightForCartFly === 'function') {
//       sticky.syncHeaderHeightForCartFly();
//     }
//   }
//   function fly(from, url, done) {
//     if (!url) return done();
//     css();
//     var size = Math.min(52, Math.max(S, Math.round(Math.min(from.width, from.height) * 0.55) || S)),
//       box = document.createElement('div');
//     box.className = 'cart-fly-to-cart';
//     box.classList.add(isStickyHeader() ? 'cart-fly-to-cart--sticky' : 'cart-fly-to-cart--main');
//     box.setAttribute('aria-hidden', 'true');
//     box.style.setProperty('--fly-w', size + 'px');
//     box.style.setProperty('--fly-h', size + 'px');
//     var im = document.createElement('img');
//     im.alt = '';
//     im.src = url;
//     box.appendChild(im);
//     var startX = from.left + from.width / 2,
//       startY = from.top + from.height / 2;
//     box.style.animation = 'none';
//     document.body.appendChild(box);
//     var run = function () {
//       var tr = cartIconRect();
//       if (!tr) {
//         box.remove();
//         return done();
//       }
//       var endX = tr.left + tr.width / 2,
//         endY = tr.top + tr.height / 2,
//         finished = false,
//         end = function () {
//           if (finished) return;
//           finished = true;
//           box.remove();
//           done();
//         };
//       box.style.setProperty('--start-x', startX + 'px');
//       box.style.setProperty('--start-y', startY + 'px');
//       box.style.setProperty('--travel-x', endX - startX + 'px');
//       box.style.setProperty('--travel-y', endY - startY + 'px');
//       void box.offsetWidth;
//       box.style.animation = '';
//       var ms = flyDurationMs(box);
//       box.addEventListener(
//         'animationend',
//         function (e) {
//           if (e.animationName === 'cart-fly-scale') end();
//         },
//         { once: true }
//       );
//       setTimeout(end, ms + 80);
//     };
//     requestAnimationFrame(function () {
//       requestAnimationFrame(run);
//     });
//   }
//   function play(o) {
//     var d = o.cartDrawer,
//       st = o.parsedState,
//       pf = o.productForm,
//       done = function () {
//         try {
//           o.onFlyComplete && o.onFlyComplete();
//         } catch (e) {
//           console.error(e);
//         }
//       };
//     if (!d || !d.renderContents) return done();
//     if (typeof d.setHeaderStickyForDrawer === 'function') d.setHeaderStickyForDrawer(true);
//     var from = rect(pf, o.quickAddOpener),
//       url = preview(pf) || cartImg(st);
//     patchIcon(st);
//     syncHeaderHeight();
//     if (reduced() || !url || !from) {
//       d.renderContents(st, { openDrawer: false });
//       return queueMicrotask(done);
//     }
//     d.renderContents(st, { openDrawer: false });
//     syncHeaderHeight();
//     fly(from, url, done);
//   }
//   window.ThemeCartFlyToCart = { play: play };
// })();



// (function () {
//   'use strict';
//   var S = 44;
//   function reduced() {
//     try {
//       return matchMedia('(prefers-reduced-motion: reduce)').matches;
//     } catch (e) {
//       return false;
//     }
//   }
//   function cartImg(o) {
//     if (!o) return '';
//     if (o.image) return o.image;
//     var it = o.items;
//     return it && it.length ? it[it.length - 1].image || '' : '';
//   }
//   function preview(pf) {
//     var root =
//       pf &&
//       (pf.closest('.wbproduct-container,.card-wrapper,.product-card-wrapper,.product') || pf);
//     var img = root && root.querySelector('.product__media-item img,.wbimgblock img,img[src]');
//     return img ? img.currentSrc || img.src || '' : '';
//   }
//   function rect(form, opener) {
//     var btn =
//       form &&
//       (form.querySelector('button[name="add"][type="submit"]') ||
//         form.querySelector('button.product-form__submit[type="submit"]') ||
//         form.querySelector('[type="submit"]'));
//     var el = btn || (form && form.querySelector('.product-form__buttons')) || opener || form;
//     if (!el || !el.getBoundingClientRect) return null;
//     var r = el.getBoundingClientRect();
//     if (r.width < 8 || r.height < 8) return null;
//     return { left: r.left, top: r.top, width: r.width, height: r.height };
//   }
//   function patchIcon(st) {
//     var html = st.sections && st.sections['cart-icon-bubble'];
//     if (!html) return;
//     var el = document.getElementById('cart-icon-bubble');
//     if (!el) return;
//     var inner = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
//     if (inner) el.innerHTML = inner.innerHTML;
//   }
//   function css() {
//     var id = 'cart-fly-to-cart-s',
//       t =
//         '.cart-fly-to-cart{--offset-y:10px;position:fixed;left:0;top:0;width:var(--fly-w,44px);height:var(--fly-h,44px);z-index:2147483646;pointer-events:none;border-radius:50%;overflow:hidden;box-shadow:0 4px 18px rgba(0,0,0,.14);opacity:1;translate:var(--start-x,0) var(--start-y,0);transform:translate(-50%,-50%);will-change:translate,transform;animation-name:cart-fly-x,cart-fly-y,cart-fly-scale;animation-timing-function:var(--x-timing),var(--y-timing),var(--scale-timing);animation-duration:var(--fly-duration,.75s);animation-delay:0,var(--fly-y-delay,0),0;animation-composition:accumulate;animation-fill-mode:both}.cart-fly-to-cart--main{--x-timing:cubic-bezier(.62,-.22,.88,.5);--y-timing:cubic-bezier(.42,0,.58,1);--fly-y-delay:.11s;--scale-timing:cubic-bezier(.85,.05,.96,1);--fly-duration:.75s}.cart-fly-to-cart--sticky{--x-timing:cubic-bezier(.88,-.2,.92,.5);--y-timing:cubic-bezier(.4,0,.6,1);--fly-y-delay:.13s;--scale-timing:cubic-bezier(.86,.08,.98,.98);--fly-duration:.9s}@keyframes cart-fly-x{to{translate:var(--travel-x,0) 0}}@keyframes cart-fly-y{to{translate:0 var(--travel-y,0)}}@keyframes cart-fly-scale{0%{opacity:1}5%{opacity:1}100%{opacity:1;transform:translate(-50%,calc(-50% + var(--offset-y))) scale(.22)}}.cart-fly-to-cart img{width:100%;height:100%;object-fit:cover;border-radius:50%}',
//       e = document.getElementById(id);
//     if (e) e.textContent = t;
//     else {
//       e = document.createElement('style');
//       e.id = id;
//       e.textContent = t;
//       document.head.appendChild(e);
//     }
//   }
//   function flyDurationMs(box) {
//     return box.classList.contains('cart-fly-to-cart--sticky') ? 900 : 750;
//   }
//   function isStickyHeader() {
//     var h = document.querySelector('.section-header');
//     return !!(h && (h.classList.contains('shopify-section-header-sticky') || h.classList.contains('cart-drawer-pinned')));
//   }
//   function cartIconRect() {
//     var target = document.querySelector('#cart-icon-bubble');
//     if (!target) return null;
//     var r = target.getBoundingClientRect();
//     return r.width > 0 && r.height > 0 && r.bottom > 0 ? r : null;
//   }
//   function syncHeaderHeight() {
//     var sticky = document.querySelector('sticky-header');
//     if (sticky && typeof sticky.syncHeaderHeightForCartFly === 'function') {
//       sticky.syncHeaderHeightForCartFly();
//     }
//   }
//   function fly(from, url, done) {
//     if (!url) return done();
//     css();
//     var size = Math.min(52, Math.max(S, Math.round(Math.min(from.width, from.height) * 0.55) || S)),
//       box = document.createElement('div');
//     box.className = 'cart-fly-to-cart';
//     box.classList.add(isStickyHeader() ? 'cart-fly-to-cart--sticky' : 'cart-fly-to-cart--main');
//     box.setAttribute('aria-hidden', 'true');
//     box.style.setProperty('--fly-w', size + 'px');
//     box.style.setProperty('--fly-h', size + 'px');
//     var im = document.createElement('img');
//     im.alt = '';
//     im.src = url;
//     box.appendChild(im);
//     var startX = from.left + from.width / 2,
//       startY = from.top + from.height / 2;
//     box.style.animation = 'none';
//     document.body.appendChild(box);
//     var run = function () {
//       var tr = cartIconRect();
//       if (!tr) {
//         box.remove();
//         return done();
//       }
//       var endX = tr.left + tr.width / 2,
//         endY = tr.top + tr.height / 2,
//         finished = false,
//         end = function () {
//           if (finished) return;
//           finished = true;
//           box.remove();
//           done();
//         };
//       box.style.setProperty('--start-x', startX + 'px');
//       box.style.setProperty('--start-y', startY + 'px');
//       box.style.setProperty('--travel-x', endX - startX + 'px');
//       box.style.setProperty('--travel-y', endY - startY + 'px');
//       void box.offsetWidth;
//       box.style.animation = '';
//       var ms = flyDurationMs(box);
//       box.addEventListener(
//         'animationend',
//         function (e) {
//           if (e.animationName === 'cart-fly-scale') end();
//         },
//         { once: true }
//       );
//       setTimeout(end, ms + 80);
//     };
//     requestAnimationFrame(function () {
//       requestAnimationFrame(run);
//     });
//   }
//   function play(o) {
//     var d = o.cartDrawer,
//       st = o.parsedState,
//       pf = o.productForm,
//       done = function () {
//         try {
//           o.onFlyComplete && o.onFlyComplete();
//         } catch (e) {
//           console.error(e);
//         }
//       };
//     if (!d || !d.renderContents) return done();
//     if (typeof d.setHeaderStickyForDrawer === 'function') d.setHeaderStickyForDrawer(true);
//     var from = rect(pf, o.quickAddOpener),
//       url = preview(pf) || cartImg(st);
//     patchIcon(st);
//     syncHeaderHeight();
//     if (reduced() || !url || !from) {
//       d.renderContents(st, { openDrawer: false });
//       return queueMicrotask(done);
//     }
//     d.renderContents(st, { openDrawer: false });
//     syncHeaderHeight();
//     fly(from, url, done);
//   }
//   window.ThemeCartFlyToCart = { play: play };
// })();


(function () {
  'use strict';
  var S = 44;
  function reduced() {
    try {
      return matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {
      return false;
    }
  }
  function cartImg(o) {
    if (!o) return '';
    if (o.image) return o.image;
    var it = o.items;
    return it && it.length ? it[it.length - 1].image || '' : '';
  }
  function preview(pf) {
    var root =
      pf &&
      (pf.closest('.wbproduct-container,.card-wrapper,.product-card-wrapper,.product') || pf);
    var img = root && root.querySelector('.product__media-item img,.wbimgblock img,img[src]');
    return img ? img.currentSrc || img.src || '' : '';
  }
  function rect(form, opener) {
    var btn =
      form &&
      (form.querySelector('button[name="add"][type="submit"]') ||
        form.querySelector('button.product-form__submit[type="submit"]') ||
        form.querySelector('[type="submit"]'));
    var el = btn || (form && form.querySelector('.product-form__buttons')) || opener || form;
    if (!el || !el.getBoundingClientRect) return null;
    var r = el.getBoundingClientRect();
    if (r.width < 8 || r.height < 8) return null;
    return { left: r.left, top: r.top, width: r.width, height: r.height };
  }
  function patchIcon(st) {
    var html = st.sections && st.sections['cart-icon-bubble'];
    if (!html) return;
    var el = document.getElementById('cart-icon-bubble');
    if (!el) return;
    var inner = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
    if (inner) el.innerHTML = inner.innerHTML;
  }
  function css() {
    var id = 'cart-fly-to-cart-s',
      t =
        '.cart-fly-to-cart{--offset-y:10px;position:fixed;left:0;top:0;width:var(--fly-w,44px);height:var(--fly-h,44px);z-index:2147483646;pointer-events:none;border-radius:50%;overflow:hidden;box-shadow:0 4px 18px rgba(0,0,0,.14);opacity:1;translate:var(--start-x,0) var(--start-y,0);transform:translate(-50%,-50%);will-change:translate,transform;animation-name:cart-fly-x,cart-fly-y,cart-fly-scale;animation-timing-function:var(--x-timing),var(--y-timing),var(--scale-timing);animation-duration:var(--fly-duration,.75s);animation-delay:0,var(--fly-y-delay,0),0;animation-composition:accumulate;animation-fill-mode:both}.cart-fly-to-cart--main{--x-timing:cubic-bezier(.62,-.22,.88,.5);--y-timing:cubic-bezier(.42,0,.58,1);--fly-y-delay:.11s;--scale-timing:cubic-bezier(.85,.05,.96,1);--fly-duration:.75s}.cart-fly-to-cart--sticky{--x-timing:cubic-bezier(.88,-.2,.92,.5);--y-timing:cubic-bezier(.4,0,.6,1);--fly-y-delay:.13s;--scale-timing:cubic-bezier(.86,.08,.98,.98);--fly-duration:.9s}@keyframes cart-fly-x{to{translate:var(--travel-x,0) 0}}@keyframes cart-fly-y{to{translate:0 var(--travel-y,0)}}@keyframes cart-fly-scale{0%{opacity:1}5%{opacity:1}100%{opacity:1;transform:translate(-50%,calc(-50% + var(--offset-y))) scale(.22)}}.cart-fly-to-cart img{width:100%;height:100%;object-fit:cover;border-radius:50%}',
      e = document.getElementById(id);
    if (e) e.textContent = t;
    else {
      e = document.createElement('style');
      e.id = id;
      e.textContent = t;
      document.head.appendChild(e);
    }
  }
  function flyDurationMs(box) {
    return box.classList.contains('cart-fly-to-cart--sticky') ? 900 : 750;
  }
  function isStickyHeader() {
    var h = document.querySelector('.section-header');
    return !!(h && (h.classList.contains('shopify-section-header-sticky') || h.classList.contains('cart-drawer-pinned')));
  }
  function cartIconRect() {
    var target = document.querySelector('#cart-icon-bubble');
    if (!target) return null;
    var r = target.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && r.bottom > 0 ? r : null;
  }
  function syncHeaderHeight() {
    var sticky = document.querySelector('sticky-header');
    if (sticky && typeof sticky.syncHeaderHeightForCartFly === 'function') {
      sticky.syncHeaderHeightForCartFly();
    }
  }
  function fly(from, url, done) {
    if (!url) return done();
    css();
    var size = Math.min(52, Math.max(S, Math.round(Math.min(from.width, from.height) * 0.55) || S)),
      box = document.createElement('div');
    box.className = 'cart-fly-to-cart';
    box.classList.add(isStickyHeader() ? 'cart-fly-to-cart--sticky' : 'cart-fly-to-cart--main');
    box.setAttribute('aria-hidden', 'true');
    box.style.setProperty('--fly-w', size + 'px');
    box.style.setProperty('--fly-h', size + 'px');
    var im = document.createElement('img');
    im.alt = '';
    im.src = url;
    box.appendChild(im);
    var startX = from.left + from.width / 2,
      startY = from.top + from.height / 2;
    box.style.animation = 'none';
    document.body.appendChild(box);
    var run = function () {
      var tr = cartIconRect();
      if (!tr) {
        box.remove();
        return done();
      }
      var endX = tr.left + tr.width / 2,
        endY = tr.top + tr.height / 2,
        finished = false,
        end = function () {
          if (finished) return;
          finished = true;
          box.remove();
          done();
        };
      box.style.setProperty('--start-x', startX + 'px');
      box.style.setProperty('--start-y', startY + 'px');
      box.style.setProperty('--travel-x', endX - startX + 'px');
      box.style.setProperty('--travel-y', endY - startY + 'px');
      void box.offsetWidth;
      box.style.animation = '';
      var ms = flyDurationMs(box);
      box.addEventListener(
        'animationend',
        function (e) {
          if (e.animationName === 'cart-fly-scale') end();
        },
        { once: true }
      );
      setTimeout(end, ms + 80);
    };
    requestAnimationFrame(function () {
      requestAnimationFrame(run);
    });
  }
  function play(o) {
    if (window._edCartGate && window._edCartGate.allowed === false) {
      window.location.href = window._edCartGate.url || '/pages/create-an-account';
      return;
    }
    var d = o.cartDrawer,
      st = o.parsedState,
      pf = o.productForm,
      openDrawer = o.openDrawer !== false,
      done = function () {
        try {
          if (openDrawer && typeof d.open === 'function') d.open();
          o.onFlyComplete && o.onFlyComplete();
        } catch (e) {
          console.error(e);
        }
      };
    if (!d || !d.renderContents) return done();
    if (typeof d.setHeaderStickyForDrawer === 'function') d.setHeaderStickyForDrawer(true);
    var from = rect(pf, o.quickAddOpener),
      url = preview(pf) || cartImg(st);
    patchIcon(st);
    syncHeaderHeight();
    if (reduced() || !url || !from) {
      d.renderContents(st, { openDrawer: false });
      return queueMicrotask(done);
    }
    d.renderContents(st, { openDrawer: false });
    syncHeaderHeight();
    fly(from, url, done);
  }
  window.ThemeCartFlyToCart = { play: play };
})();
